import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AlertComponent } from './alert/alert.component';
import { ProcessingDialogComponent } from './processing-dialog/processing-dialog.component';
import { AlertSnackBarComponent } from './snack-bar/alert-snack-bar/alert-snack-bar.component';

const COMPONENTS = [AlertComponent, ProcessingDialogComponent];

@NgModule({
  declarations: [COMPONENTS, AlertSnackBarComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatRippleModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressBarModule,
  ],
  // Source of truth for apps that import FeedbackModule without MaterialModule
  // (e.g. universal-login, ccm, lfs). MaterialModule still provides the same token
  // for full-admin consumers.
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
  exports: [COMPONENTS],
})
export class FeedbackModule {}
